import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Banka } from './banka';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-banka',
  templateUrl: './banka.component.html'
})
export class BankaComponent
 extends BaseModalContainer<Banka>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Banka>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

 

  ngOnInit() {
  }

}
